import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled.section`
  width: 100%;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

export const ImgName = styled.img`
  width: 115px;
  height: 18px;
  margin-left: 45px;
  margin-bottom: 5px;
`;

export const DesktopVersion = styled.div`
  && {
    display: none;

    @media (min-width: 476px) {
      display: block;
    }
  }
`;

export const MobileVersion = styled.div`
  && {
    display: none;

    @media (max-width: 475px) {
      display: block;
    }
  }
`;

export const Title = styled(Typography)`
  && {
    text-align: center;
    font-family: "Figtree", "Roboto", "sans-serif";
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 26.4px;
    color: #ffffff;
  }
`;

export const Subtitle = styled(Typography)`
  && {
    font-family: "Figtree", "Roboto", "sans-serif";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 33px;
    color: #ffffff;
  }
`;